import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useMemo } from "react";
import { useAuth } from "./AuthProvider";
import { cognitoApi, passkeysPossible } from "./cognito-api";

/**
 * How many passkeys the signed-in user has, asked of Cognito once per session
 * with the user's own access token (section 13.3) and kept until a passkey is
 * enrolled or removed. Drives the passkey nudge; the Account card keeps its own
 * fuller list.
 */
export function usePasskeyCount() {
  const { config, session, me } = useAuth();
  const api = useMemo(() => (config ? cognitoApi(config) : undefined), [config]);
  const token = session?.accessToken;
  return useQuery({
    queryKey: ["passkeys", session?.username ?? session?.email ?? ""],
    queryFn: async () => (await api!.listPasskeys(token!)).Credentials?.length ?? 0,
    enabled: Boolean(api && token && me && !me.identityProvider && passkeysPossible()),
    staleTime: Infinity,
  });
}

export function useInvalidatePasskeys() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ["passkeys"] });
}
